import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { IProfessionalProfile } from 'models/Professional/IProfessionalProfile'

interface ProductResponse {
  id: number
  code: string
  name: string
  product_group: {
    code: string
  }
}

interface Response {
  person_general: {
    first_name: string
    last_name: string
    picture_url: string
    friendly_url: string
  }
  person_profile: {
    id: number
    documents: {
      type_name: string
      value: string
    }[]
    products: {
      appointments: {
        id: number
      }[]
      product: ProductResponse
    }[]
  }[]
  enable_new_patients: boolean
}

export async function getProfessionalProfile(professionalSlug: string): Promise<IProfessionalProfile> {
  const { data } = await axios.get<Response>(apiEndpoints.PROFESSIONAL_DETAIL(professionalSlug))

  const formattedData: IProfessionalProfile = {
    firstName: data.person_general.first_name,
    lastName: data.person_general.last_name,
    pictureUrl: data.person_general.picture_url,
    friendlyUrl: data.person_general.friendly_url,
    documents: data.person_profile[0].documents.map((document) => ({
      typeName: document.type_name,
      value: document.value,
    })),
    enableNewPatients: data.enable_new_patients,
    personProfileId: data.person_profile[0].id,
    productCode: data.person_profile[0].products[0].product.code,
    productGroupCode: data.person_profile[0].products[0].product.product_group.code,
    productAppointmentId: data.person_profile[0].products[0].appointments[0].id,
  }

  return formattedData 
}